import Model, { hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ChannelNotificationModel extends Model {
  @hasMany('airbnb-official-notification', {
    inverse: 'channelNotification',
    async: false,
  })
  airbnbOfficialNotifications!: ModelRegistry['airbnb-official-notification'][];

  @hasMany('airbnb-official-opportunity', {
    inverse: 'channelNotification',
    async: false,
  })
  airbnbOfficialOpportunities!: ModelRegistry['airbnb-official-opportunity'][];

  @hasMany('airbnb-official-resolution', {
    inverse: 'channelNotification',
    async: false,
  })
  airbnbOfficialResolutions!: ModelRegistry['airbnb-official-resolution'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'channel-notification': ChannelNotificationModel;
  }
}
